export default __webpack_public_path__ + "static/media/loadTypes.616f437c.svg";